import { projectDataApi } from './projectDataApi'
import { ReviewerBugsResponseSchema, ReviewerSessionPageSchema, ReviewerSessionQuerySchema, ReviewerListResponseSchema, ReviewerResponseSchema, type ReviewerKey, type ReviewFilter, type ReviewerResponse } from '../schemas/sessionReviewers'
import type { z } from 'zod'

const api = projectDataApi.injectEndpoints({
  endpoints: builder => ({
    getSessionReviewerBugs: builder.infiniteQuery<z.infer<typeof ReviewerBugsResponseSchema>, { projectId: string; reviewer: ReviewerKey }, number>({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: lastPage => lastPage.has_more ? lastPage.page + 1 : undefined,
      },
      query: ({ queryArg: { projectId, reviewer }, pageParam: page }) => ({ url: '/api/project-session-reviewers', params: { project_id: projectId, reviewer, bugs: '1', page } }),
      transformResponse: (response: unknown) => ReviewerBugsResponseSchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'Project', id: `bugs:${args.projectId}` }, { type: 'ProjectUserSessions', id: args.projectId }],
    }),
    getReviewerSessions: builder.query<z.infer<typeof ReviewerSessionPageSchema>, { projectId: string; query: z.infer<typeof ReviewerSessionQuerySchema> }>({
      query: ({ projectId, query }) => ({ url: '/api/project-session-reviewers', params: { project_id: projectId, sessions: '1', query: JSON.stringify(query) } }),
      transformResponse: (response: unknown) => ReviewerSessionPageSchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }],
    }),
    getSessionReviewers: builder.query<z.infer<typeof ReviewerListResponseSchema>, string>({
      query: projectId => ({ url: '/api/project-session-reviewers', params: { project_id: projectId, summary: '1' } }),
      transformResponse: (response: unknown) => ReviewerListResponseSchema.parse(response),
      providesTags: (_result, _error, projectId) => [{ type: 'ProjectUserSessions', id: projectId }, { type: 'Project', id: `bugs:${projectId}` }],
    }),
    getSessionReviewer: builder.infiniteQuery<ReviewerResponse, { projectId: string; reviewer: ReviewerKey; filter: ReviewFilter }, number>({
      infiniteQueryOptions: {
        initialPageParam: 0,
        getNextPageParam: lastPage => lastPage.has_more ? lastPage.page + 1 : undefined,
      },
      query: ({ queryArg: { projectId, reviewer, filter }, pageParam: page }) => ({ url: '/api/project-session-reviewers', params: { project_id: projectId, reviewer, filter: JSON.stringify(filter), page } }),
      transformResponse: (response: unknown) => ReviewerResponseSchema.parse(response),
      providesTags: (_result, _error, args) => [{ type: 'ProjectUserSessions', id: args.projectId }, { type: 'Project', id: `bugs:${args.projectId}` }],
    }),
  }),
})
export const { useGetSessionReviewerBugsInfiniteQuery, useGetReviewerSessionsQuery, useGetSessionReviewersQuery, useGetSessionReviewerInfiniteQuery } = api
